const DatoCmsPlugin = require('datocms-plugins-sdk');

import './style.scss';


DatoCmsPlugin.init(async (plugin) => {
	const { locale } = plugin;

	const wrapper = document.createElement('div');
	wrapper.classList.add('wrapper');

	const cacheBuster = `${new Date().getTime()}`;
	let fullUrl = plugin.parameters.global.sitemapUrl;

	if (fullUrl.indexOf('?') === -1) {
		fullUrl += `?${cacheBuster}`;
	} else {
		fullUrl += `&${cacheBuster}`;
	}

	const sitemapXML = await fetch(fullUrl)
					.then(response => response.text())
					.then(data => {
						const parser = new DOMParser();
						const xml = parser.parseFromString(data, "application/xml");

						return xml;
					});

	const stories = Array.from(sitemapXML.getElementsByTagName('loc')).map(u => u.textContent).sort((a, b) => {
		if (a.indexOf(`/${locale}/`) !== -1) {
			return 1;
		} else {
			return -1;
		}
	});

	stories.forEach((slug) => {
		const link = document.createElement('button');

		link.classList.add('item');

		link.textContent = slug;

		link.onclick = function(e) {
			plugin.setFieldValue(plugin.fieldPath, e.target.innerHTML);
		}

		wrapper.appendChild(link);
	});

	document.body.appendChild(wrapper);

	plugin.startAutoResizer();
});
